import { useState, ElementType } from 'react';
import { DisclaimerContainer, DisclaimerContent, DisclaimerText } from './styles';
import type { SvgIconProps } from '@mui/material';
import { useTranslation } from '@/hooks/useTranslation';
import { SafeMarkdown } from '@/components/atoms/markdown/safe';

interface DisclaimerProps {
  text: string;
  icon: ElementType<SvgIconProps>;
  showMoreButton?: boolean;
}

export const Disclaimer = ({ text, icon: Icon, showMoreButton = false }: DisclaimerProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { t } = useTranslation();

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const displayText =
    showMoreButton && !isExpanded ? (
      text.length > 150 ? (
        <SafeMarkdown text={`${t('label.label.disclaimer_text').substring(0, 150)}...`} />
      ) : (
        <SafeMarkdown text={t('label.label.disclaimer_text')} />
      )
    ) : (
      <SafeMarkdown text={t('label.label.disclaimer_text')} />
    );

  const shouldShowButton = showMoreButton && text.length > 150;

  return (
    <DisclaimerContainer>
      <Icon sx={{ fontSize: 24, color: '#002d54' }} />
      <DisclaimerContent>
        <DisclaimerText variant="body2">{displayText}</DisclaimerText>
        {shouldShowButton && (
          <button onClick={toggleExpanded}>
            {isExpanded
              ? t('button.button.see_less_disclaimer_text')
              : t('button.button.see_more_disclaimer_text')}
          </button>
        )}
      </DisclaimerContent>
    </DisclaimerContainer>
  );
};
